import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

const circleButtonsStyle = `
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
    color: ${Colors.Black.V50};
`;

export const ActionSection = styled.div`
    display: flex;
    justify-content: space-between;

    > .sds-base-button.ant-btn.default {
        ${circleButtonsStyle};
    }

    > span .sds-base-button.ant-btn.default {
        ${circleButtonsStyle};
    }
`;

export const BadgesContainer = styled.div`
    margin-right: ${Spacing.XS}px;
`;
